import { Get, Post, Put } from '../helpers';
import { IAnnouncement } from '@/types/announcement.types';
import { SqsSocketTypes } from '@/types/custom-socket.types';

// Event Announcements
export const SaveAnnouncement_V2 = async ({
  channel,
  content,
  defaultLanguage,
}: {
  content: IAnnouncement;
  defaultLanguage: string;
  channel: number;
}): Promise<IAnnouncement> => {
  return Post({
    path: `/v3/admin/channel/${channel}/notifications/announcement_v2`,
    body: { content, defaultLanguage },
  });
};

export interface IUpdateAnnouncementParams {
  announcement: IAnnouncement;
  defaultLanguage: string;
  channel: number;
  deleteAnnouncement?: boolean;
  cancelAnnouncement?: boolean;
  previouslyScheduledSwitchedToImmediate?: boolean;
}

export const UpdateAnnouncement_V2 = async ({
  announcement,
  defaultLanguage,
  channel,
  deleteAnnouncement = false,
  cancelAnnouncement = false,
  previouslyScheduledSwitchedToImmediate = false,
}: IUpdateAnnouncementParams): Promise<IAnnouncement> => {
  return Put({
    path: `/v3/admin/channel/${channel}/notifications/announcement_v2`,
    body: {
      announcement,
      deleteAnnouncement,
      cancelAnnouncement,
      previouslyScheduledSwitchedToImmediate,
      defaultLanguage,
    },
  });
};

export const SendAnnouncement = async (content: Partial<IAnnouncement>): Promise<{ msg: string }> => {
  return Post({
    path: `/v3/admin/notifications/announcement`,
    body: { message_type: SqsSocketTypes.ANNOUNCEMENT, content },
  });
};

export const SaveScheduledAnnouncement = (announcement: Partial<IAnnouncement>): Promise<IAnnouncement> => {
  return Post({
    path: `/v3/admin/notifications/scheduled-announcement`,
    body: announcement,
  });
};

export const GetScheduledAnnouncements = (eventUuid: string): Promise<IAnnouncement[]> => {
  return Get({
    path: `/v3/admin/notifications/scheduled-announcement/${eventUuid}`,
  });
};

export const UpdateAnnouncement = (announcement: IAnnouncement): Promise<IAnnouncement> => {
  return Put({
    path: `/v3/admin/notifications/scheduled-announcement`,
    body: { announcement, uuid: announcement.uuid, deleteAnnouncement: false },
  });
};

export const DeleteAnnouncement = (announcement: IAnnouncement): Promise<IAnnouncement> => {
  return Put({
    path: `/v3/admin/notifications/scheduled-announcement`,
    body: { announcement, uuid: announcement.uuid, deleteAnnouncement: true },
  });
};
